export default {
  content: {
    iosPromptPart1: "Last ned appen på din iPhone:<br /> trykk ",
    iosPromptPart2: "og så <em>'Legg til på Hjem-skjerm.'</em>",
    bookingStatus: {
      statusNew: {
        label: "Sendt",
        desc: "Din bestilling er sendt vår vei. Vi trenger bare litt tid for å se igjennom den."
      },
      statusAccept: {
        label: "Bekreftet",
        desc: "Flott! Din bestilling er gjennomgått og bekreftet.",
        pickupText: "Din sjåfør venter på deg utenfor terminalen.",
        pickupTextDeparture: "Vi informerer deg om hentetidspunkt den %time% rundt 18:00."
      },
      statusReject: {
        label: "Avvist",
        desc: "Beklager! Vi kunne dessverre ikke ta imot bestillingen.",
        moreInfo: "For mer informasjon vennligst",
        contact: "kontakt oss"
      },
      statusCanceled: {
        label: "Kansellert",
        desc: "Vi har kansellert bestillingen din. Takk for at du gav oss beskjed!",
        moreInfo: "Betalingen din er tilbakebetalt og vil være på kontoen din innen 10 virkedager.",
        infoWithoutRefund: 'Du avbestiller mindre enn 8 timer før planlagt flytur. Du blir ikke tilbakebetalt.',
      },
      statusAssigned: {
        descDeparture: "er klar for å hente deg i morgen kl.",
        descTodayDeparture: "er klar for å hente deg i dag kl.",
        descNormal: "vil vente på deg utenfor terminalen.",
        contactInfo: "Du kan kontakte han på",
        desc: "Møt din sjåfør.",
        label: "Klar"
      },
      statusCompleted: {
        desc: "Vi blir veldig glade om du kan",
        review: 'vurdere turen din',
        tripReview: 'Vurder turen din',
        label: "Ferdig",
        allDone: "Ferdig!",
        thanksForReview: 'Takk for din tilbakemelding!',
      },
      statusNoShow: {
        moreInfo: "Tips: Om du kansellerer bestillingen vil sjåføren få beskjed om det.",
        desc: "(<span><strong>%driver%</strong> ventet på deg, men du møtte ikke opp.</span>)",
        label: "No show"
      },
    },
    layout: {
      header: {
        welcomeMessage: "Hei! Glad for å se deg igjen.",
        registerMessage: "Hallo! Har vi møtt før?",
        registerSecondMessage: "Nei? La oss bli kjent.",
        registerButton: "Registrer deg",
        helloAgainTitle: "Hei igjen!",
        logIn: "Logg inn",
        activeBookingCount: "<span>Du har </span> %count% kommende bestillinger"
      },
      landingLayout: {
        title: "Rimelig og pålitelig",
        desc: "<span>Din reise til flyplassen</span> har aldri vært enklere!",
        bookNow: "Bestill nå!",
        questionsTitle: "Spørsmål?",
        poweredByStripe: "Powered by Stripe & iZettle®"
      },
      menuMain: {
        home: "Hjem",
        booking: "Bestilling",
        howItWorks: "Hvordan det fungerer",
        aiportTransfer: "Oslo Gardermoen",
        pricing: "Pris",
        faq: "FAQ",
        contact: "Kontakt oss",
      },
      sidebarAndHeader: {
        dashboard: 'Turer',
        booking: 'Bestilling',
        myAccount: 'Min konto',
        help: 'Hjelp',
        editReservation: 'Endre bestilling',
        backToEditTitle: 'Tilbake til endre bestilling',
        backToHelpTitle: 'Tilbake til Hjelp',
        backToDashboardTitle: 'Tilbake til Turer',
      }
    },
    landing: {
      homepage: {
        mainpage: {
          title: "Dør-til-dør",
          subtitleFirst: "Flyplasstransport",
          subtitleSecond: "Oslo Torp"
        },
        about: {
          headline: {
            title: "Flyreisen gjort enkelt",
            description: "Vi kjører. Du flyr."
          },
          profits: {
            first: {
              title: "Enkel bestilling",
              description: "Fortell oss hvor du flyr til og bestill flyplasstransport enkelt. Du blir hentet hjemmefra, jobben eller flyplassen - hvor det passer deg best. Sjåføren vil kontakte deg noen minutter før ankomst.",
              footer: "Spørsmål?",
              linkFaq: {
                preTitle: "Sjekk vår",
                title: "FAQ"
              },
              linkContact: {
                separator: " eller ",
                title: "Kontakt oss"
              }
            },
            second: {
              title: "Punktlig sjåfør",
              description: "Din sjåfør vil være i tide for å plukke deg opp. Vi ankommer til flyplassen 1,5 timer før avreise. Hvis flyankomsten til Torp er forsinket vil sjåføren vente på deg, uten at det koster deg noe mer.",
              footer: "Du kan sjekke status eller endre bestillingen.",
              linkTitle: "Opprett konto"
            },
            third: {
              title: "Fastpris",
              description: "Betalingsmåter som passer dine behov. Betal på nett eller direkte til sjåføren. Ingen skjulte kostnader. Du vet alltid hvor mye du vil betale.",
              footer: "Hvor mye koster det?",
              linkTitle: "Sjekk prisen"
            },
          }
        },
        testimonials: {
          title: "Våre glade kunder",
          description: "Kjør med oss og bli en av dem",
          items: {
            first: {
              author: "Agnes H.",
              content: "Profesjonell og punktlig sjåfør. Anbefales!",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            second: {
              author: "Bartholomew O.",
              content: "Dagen før avreise mottok jeg en SMS med hentingstidspunktet kl. 16:16. Nesten tre timer tidligere enn jeg ble fortalt. Så pluss for det. På turen til flyplassen gikk alt bra. Hyggelig sjåfør og null forsinkelser.",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            third: {
              author: "Michaela S.",
              content: "God, rask og pålitelig service.",
              logoAlt: "Google",
              url: "google.com"
            },
            fourth: {
              author: "Matthew S.",
              content: "Bussen var bra. En vennlig og profesjonell sjåfør kontaktet oss et par minutter før henting. Ved ankomst til Torp er det umulig å ikke se merke til bussen på flyplassen. Jeg anbefaler det som et billigere alternativ.",
              logoAlt: "Google",
              url: "google.com"
            }
          },
          footer: {
            title: "Anmeldelse fra"
          }
        }
      },
      howItWorks: {
        title: "Hvordan det fungerer",
        description: "Bli hentet hjemme, del turen med andre og betal mindre.",
        list: {
          first: {
            title: "Rask bestilling",
            description: "Fortell oss hvor du flyr, bestill flyplasstransporten online eller ved å ringe oss. Vi henter deg hjemme eller på jobben - hvor det passer deg best."
          },
          second: {
            title: "Alltid oppdatert",
            description: "Hvis du oppretter en konto, kan du endre og sjekke statusen for din bestilling. Hvis du ikke har en konto, vil du motta en bekreftelsesmelding en dag før avreise. Sjåføren vil kontakte deg noen minutter før ankomst."
          },
          third: {
            title: "Pålitelig transport",
            description: "Vær sikker på at sjåføren kommer som avtalt for å hente deg. Hvis flyankomsten din er forsinket, vil sjåføren vente på deg."
          },
          fourth: {
            title: "Praktisk betaling",
            description: "Velg betalingsmetoden som passer deg best. Du kan betale direkte til sjåføren eller på nett med kort"
          }
        }
      },
      transferPage: {
        hero: {
          badge: "PKS Oslo flyplasstransport",
          title: "Direkte tur fra Oslo til Gardermoen flyplass",
          lede: "Vi henter deg hjemme og kjører deg til terminalen på 40–60 minutter. Fast pris, en liten buss og polskspråklig service gir en rolig start på reisen.",
          kpi: {
            first: "<strong>fra 260 NOK</strong> / person – ingen skjulte kostnader",
            second: "Maks <strong>3 adresser</strong> underveis",
            third: "SMS med bekreftelse og hentetidspunkt"
          },
          cta: "Bestill tur",
          hint: "Bestill minst 3 timer før flyavgang",
          imgAlt: "PKS Oslo-sjåfør foran transportbussen"
        },
        benefits: {
          title: "Hvorfor velger passasjerene PKS Oslo?",
          subtitle: "En tjeneste laget for en komfortabel reise til Gardermoen.",
          list: {
            first: {
              title: "🏠 Henting ved døren",
              description: "Sjåføren kommer rett til adressen du oppgir og hjelper med bagasjen. Du slipper å bytte transport."
            },
            second: {
              title: "💳 Oversiktlig pris",
              description: "Fast pris <strong>fra 260 NOK / person</strong>. Du betaler for en plass, ikke for hele turen som i en taxi."
            },
            third: {
              title: "🧳 Komfortabel buss",
              description: "En liten buss betyr maks tre passasjerer underveis og kort reisetid, uten trengsel og unødvendige stopp."
            }
          }
        },
        process: {
          title: "Hvordan foregår transporten?",
          subtitle: "Tre enkle steg – fra bestilling til innsjekking.",
          steps: {
            first: "<strong>Du bestiller turen</strong> på nett på få minutter og oppgir henteadressen.",
            second: "<strong>Dagen før avreise får du en SMS</strong> med nøyaktig tidspunkt for når sjåføren kommer. Vanlig reisetid er 40–60 minutter.",
            third: "<strong>Sjåføren henter deg hjemme</strong> og kjører deg direkte til Gardermoen flyplass."
          }
        },
        comparison: {
          title: "PKS Oslo, Flybussen eller taxi?",
          subtitle: "Sammenlign de mest populære måtene å komme seg til flyplassen på.",
          columns: {
            pks: "PKS Oslo",
            flybussen: "Flybussen",
            taxi: "Taxi"
          },
          rows: {
            pickup: {
              label: "Henting ved døren",
              pks: "✅ Ja",
              flybussen: "❌ Nei (holdeplass)",
              taxi: "✅ Ja"
            },
            price: {
              label: "Pris",
              pks: "<strong>fra 260 NOK / person</strong>",
              flybussen: "ca. 260 NOK / person",
              taxi: "~900–1200 NOK per tur"
            },
            duration: {
              label: "Reisetid",
              pks: "⏱️ 40–60 min",
              flybussen: "60–90 min",
              taxi: "⏱️ 40–60 min"
            },
            stops: {
              label: "Stopp underveis",
              pks: "<strong>Maks 3 adresser</strong>",
              flybussen: "Mange stopp",
              taxi: "Ingen (privat tur)"
            },
            luggage: {
              label: "Bagasje",
              pks: "Hjelp med lasting, inkludert",
              flybussen: "Inkludert",
              taxi: "Inkludert"
            },
            language: {
              label: "Servicespråk",
              pks: "Polsk",
              flybussen: "NO / EN",
              taxi: "NO / EN"
            }
          },
          disclaimer: "Estimerte taxikostnader er basert på typiske priser i Oslo (kan variere avhengig av selskap og tidspunkt)."
        },
        quotes: {
          title: "Hva sier passasjerene?",
          first: {
            text: "«Sjåføren kom presis, turen var rask og uten stress. Anbefales!»",
            cite: "— Kasia, Oslo"
          },
          second: {
            text: "«For familien vår er dette den beste måten å komme til flyplassen: komfortabelt og til en flott pris.»",
            cite: "— Piotr, Drammen"
          }
        },
        info: {
          title: "Transport Oslo – Gardermoen flyplass",
          first: "Ser du etter en enkel reise til Gardermoen flyplass? PKS Oslo er en pålitelig <strong>transport fra Oslo til flyplassen</strong> uten stress og bytte av transport. Vi henter deg hjemme og stopper ved maks tre adresser underveis. Vi kjører hver dag og tilpasser hentetidspunktet til flyet ditt.",
          second: 'Turen tar vanligvis <strong>40–60 minutter</strong>, og bestillingen tar bare noen få klikk. Etter bestilling får du en SMS-bekreftelse og kontaktinformasjon til sjåføren. Spørsmål? Ring <strong>+47 96 70 11 03</strong> eller send e-post til <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
        }
      },
      faq: {
        title: "FAQ",
        description: "Liste over ofte stilte spørsmål",
        generalTitle: "Generelt",
        paymentTitle: "Betaling",
        accountTitle: "Konto",
        generalQuestions:
          [
            {
              title: 'Hvordan bestiller jeg minibuss til Torp?',
              paragraph: 'Du kan bestille minibuss til Torp ved å bruke vårt bestillingsskjema eller ringe oss på <a href="tel:96701103">96 70 11 03</a>. Fortell oss hvor vi skal hente deg og hvilken flyvning du skal til for å legge inn bestillingen.'
            },
            {
              title: 'Hvor finner jeg dere på flyplassen?',
              paragraph: 'Det er enkelt å finne sjåføren på flyplassen. Sjåføren vil vente på deg utenfor ankomsthallen med et blått PKS Oslo-skilt. Gå til ham og han vil vise deg til minibussen. <br /><br />Tips: Husk å slå på telefonen etter at du har landet fordi sjåføren kan prøve å kontakte deg!'
            },
            {
              title: 'Tilbyr dere flyplasstransport til Gardermoen?',
              paragraph: 'Vi tilbyr ikke delt transport til Gardermoen. <br /><br /> Hvis dere er en gruppe på 5 eller flere passasjerer, kan vi tilby dere en privat minibuss. For å bestille en privat minibuss, vennligst kontakt oss på <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
            },
            {
              title: 'Jeg finner ikke flyvningen min.',
              paragraph: 'Hvis flyet ikke vises i bestillingsskjemaet, betyr det at vi ikke kjører til den flyavgangen. Du kan prøve å finne et annet fly rundt samme tidspunkt. Vi vil være på flyplassen ca 1,5 time før planlagt flyavgang.'
            },
            {
              title: 'Når vil minibussen til flyplassen hente meg?',
              paragraph: 'Vi har ikke en fast tidsplan fordi vi tilbyr dør til dør service. Ruten er planlagt dagen før og du vil motta en SMS dagen før avreise kl. 18.00 med tidspunktet for henting. <br /><br />Hvis hentingstidspunktet ikke fungerer for deg - ikke stress. Du kan alltid kansellere bestillingen gratis. Hvis du har betalt med kort, vil du bli tilbakebetalt innen 10 virkedager.'
            },
            {
              title: 'Hvilke flyvninger kjører dere til?',
              paragraph: 'Du finner alle flyene vi kjører til i vår booking app. Hvis du ikke finner flyet ditt, kan du prøve å finne en annen flytur som er rundt samme tid.'
            },
            {
              title: 'Kan jeg endre bestillingen til en annen dato?',
              paragraph: 'Hvis du vil endre datoen for din reise kan du avbestille din eksisterende bestilling og opprette en ny. Hvis du har betalt med kort vil du automatisk bli tilbakebetalt om du kansellerer turen din 8 timer før flyavgangen / flyankomsten din.'
            },
            {
              title: 'Har dere barneseter?',
              paragraph: 'Ja. Når du bestiller gjennom vår booking app kan du velge hvilken type sikkerhetssete du trenger. Hvis du bestiller via telefon, vil vår medarbeider finne et passende sikkerhetssete for deg.'
            }
          ]
        ,
        paymentQuestions:
          [
            {
              title: 'Kan jeg betale med kort?',
              paragraph: 'Ja. Du kan betale med kort via vår app, eller så kan du betale direkte til sjåføren.'
            },
            {
              title: 'Kan jeg betale kontant?',
              paragraph: 'Ja, vi tar imot kontanter hos sjåfør.'
            },
            {
              title: 'Kan jeg få pengene mine tilbakebetalt?',
              paragraph: 'Hvis du avbestiller reisen 8 timer før flyturen, tilbakebetaler vi hele beløpet. Det kan ta opptil 10 virkedager før pengene er tilbake på kontoen din.'
            },
          ],
        accountQuestions:
          [
            {
              title: 'Hvordan oppretter jeg en konto?',
              paragraph: 'Du kan opprette en konto via vår registreringsside. Du må verifisere telefonnummeret ditt for å kunne bruke kontoen din.'
            },
            {
              title: 'Er det mulig å endre bestillingen min?',
              paragraph: 'Du kan fritt redigere bestillingen din frem til kl. 18.00 en dag før flyavgangen. Du kan endre hvor mange passasjerer dere er, adressen vi skal hente på eller hvilke barneseter som trengs.'
            },
            {
              title: 'Hvordan kan jeg kansellere bestillingen min?',
              paragraph: 'Du kan avbestille bestillingen din ved å logge deg på kontoen din, gå til "Turer" og klikke på kanseller knappen. <br /><br />Hvis du ikke har en konto, kan du kansellere bestillingen ved å ringe oss på <a href="tel:96701103">96 70 11 03</a> og en av våre medarbeidere vil avbestille for deg.'
            },
            {
              title: 'Jeg glemte passordet mitt.',
              paragraph: 'Du kan opprette et nytt passord ved å bruke å klikke "Jeg har glemt passordet" når du skal logge inn. Du vil motta en SMS-kode på ditt registrerte telefonnummer og deretter kan du opprette et nytt passord.'
            },
            {
              title: 'Jeg har et nytt telefonnummer.',
              paragraph: 'Du kan endre telefonnummeret ditt på siden "Min konto" etter at du har logget inn.'
            },
          ]
      },
      contact: {
        title: "Kontakt",
        description: "Vi svarer gjerne på dine spørsmål.",
        desc: {
          title: "Ta kontakt!",
          content: "Vi vil gjerne høre fra deg.",
          paragraphs: {
            first: {
              title: "Vårt kontor jobber hver dag",
              desc: "fra 08.00 til 21.00"
            },
            second: {
              title: "Hva kan vi hjelpe deg med?",
              //              desc: "We’re here to help"
            },
            third: {
              title: "Legge inn bestilling",
              desc: "Du kan bestille flybuss til Torp ved å ringe oss eller bruke vår app."
            },
            fourth: {
              title: "Kundeservice",
              desc: "Har du spørsmål angående din bestilling eller vår tjeneste? Ta kontakt så svarer vi gjerne på det du måtte lure på!"
            }
          }
        },
        form: {
          title: "Kontakt oss",
          inputs: {
            name: {
              label: "Navn / Firmanavn",
              placeholder: "Ditt navn"
            },
            email: {
              label: "epost",
              placeholder: "Din epost"
            },
            message: {
              label: "Din beskjed",
              placeholder: "Jeg vil fortelle dere.."
            },
            sendButton: "Send",
            sendingButton: 'Sender...'
          }
        }
      },
      pricing: {
        title: "Våre priser",
        desc: "Pris for dør-til-dør og fra bussholdeplass til Torp",
        adults: "voksne",
        kids: "barn*",
        info: "*Rabbaterte billetter for barn opp til 12 år.",
        infoPromotion: "**Kampanjen varer fra 17.08.2023 til 15.01.2024",
        doorToDoor: {
          titleGardermoen: "Dør-til-dør Oslo Gardermoen",
          title: "Dør-til-dør Oslo Sandefjord Torp",
          column: "dør-til-dør",
        },
        busStop: {
          title: "Bussholdeplass Oslo Sandefjord Torp",
          column: "bussholdeplass",
        }
      },
      termsAndConditions: {
        title: "Vilkår og betingelser",
        desc: "Regler og betingelser som gjelder under turen med PKS Oslo",
        general: {
          title: "Generelle regler",
          list: [
            { content: 'Operatøren for flyplasstransporten er Flyo AS med base på Bekkenstenveien 53B, Oslo, heretter kalt "Transportør".' },
            { content: "Disse vilkårene omfatter reglene for salg av billetter, transport av passasjerer med bagasje for Flyo AS." },
            { content: 'Dokument som tillater transporten er "SMS-bekreftelse", "E-postbekreftelse" eller "Kvittering" heretter kalt "Billett".' },
            { content: 'Ved å lage en bestilling hos Flyo AS aksepterer du "Vilkår og betingelser".' }
          ]
        },
        booking: {
          title: "Bestillingsvilkår",
          list: [
            { content: "Bestilling av flyplasstransport kan gjøres ved hjelp av bestillingsapplikasjonen eller ved å ringe kundeservice. Bestillingen er bekreftet når bruker får en bekreftelses e-post eller SMS." },
            { content: "Det er ikke nødvendig å skrive ut bekreftelsen. Sjåføren vil bli informert om alle passasjerene og vil bare trenge navn og / eller telefonnummer." },
            { content: "Kundedata blir ikke delt eller solgt til tredjeparter, og all kundedata lagres i henhold til norsk lov." },
            { content: "Flyo AS er ansvarlig for ytelsen og kvaliteten på tjenesten som er solgt til deg." },
            {
              content: "Flyo AS er ansvarlig for følgende:",
              list: [
                { content: "kredittkorttransaksjoner gjort via denne nettsiden." },
                { content: "informere når sjåføren skal være på avtalt hentested en dag før avreise." },
                { content: "informere om eventuelle vesentlige endringer i bestillingen." },
              ]
            },
            { content: "Bestillingen blir bindende når den er bekreftet på telefon eller skriftlig av Flyo AS. Online bestillinger blir bindende når en bekreftelses e-post er mottatt." },
            { content: "For å avbestille eller endre en bestilling vennligst kontakt PKS Oslo via e-post: <a href='mailto:info@pksoslo.com'> info@pksoslo.com </a>. Det kan også gjøres manuelt gjennom vår booking app." },
            { content: "Avbestilling kan gjøres opp til 8 timer før planlagt fly med full refusjon. Tilbakebetaling vil ikke bli foretatt dersom avbestilling gjøres mindre enn 8 timer før planlagt flytur." },
            { content: "Endring av bestillingen til en annen dato er gratis, om det gjøres mer enn 8 timer før planlagt avreise." },
            { content: "Det er mulig å endre antall passasjer, adresse og barneseter fram til kl. 18.00 en dag før avreise. Det er gratis å endre fram til da." },
            { content: "Prisene er i norske kroner (NOK). Alle priser er inkludert moms." },
          ]
        },
        carrier: {
          title: "Transportør",
          list: [
            { content: "Transportør er ikke ansvarlig for forsinkelser og deres videre konsekvenser som skyldes administrative forhold (for eksempel kontroll av Politi eller Statens Vegvesen) eller andre forhold som er utenfor transportørens kontroll (f.eks. Tekniske problemer, værforhold, trafikkorker)." },
            { content: "Transportøren vil ha som mål å transportere passasjer og bagasje innen rimelig tid i henhold til reiseplanen, men av grunner utenfor kontroll kan vi ikke garantere dette." },
            { content: "Transportør forbeholder seg retten til å ha koblet transport under reisen på grunn av logistiske årsaker eller for passasjerenes sikkerhet." },
            { content: "Passasjerer som ikke er i stand til å reise på grunn av Transportørens skyld, har krav på et refusjonsbeløp tilsvarende den ubrukte bestillingen." },
            { content: "Bestilling av minibuss gjøres via telefon eller via bestillingsskjemaet på <a href='http://www.pksoslo.com'> www.pksoslo.com </a>. Bestillingen er bekreftet når du mottar en bekreftelses-epost." },
            {
              content: "Transportøren har rett til ikke å tillate passasjerer på bussen eller nekte videre transport uten refusjon av kostnader pålagt av passasjeren, når passasjeren:",
              list: [
                { content: "ikke overholder reglene i disse forskriftene," },
                { content: "påvirkes av alkohol eller rusmidler" },
                {
                  content: "er i en tilstand eller oppfører seg på en måte som kan påvirke sikkerheten eller komforten av medpassasjerer.<br>De juridiske konsekvensene av disse situasjonene holdes av passasjeren."
                }
              ]
            },
            { content: "Det er ikke tillatt å konsumere alkoholholdige drikker, narkotika eller røyk." },
            { content: "Det er bare tillatt å ta med enkelte kjæledyr etter å ha tidligere informert Transportøren. Det transporterte dyret må være ordentlig sikret, være i et bur og plasseres på setet ved siden av passasjeren. Transport av dyr må gjøres uten å forstyrre andre passasjerer under reisen." },
            { content: "Kostnaden for transport, skatter, avgifter og gebyrer vil ikke tilbakebetales dersom passasjeren ikke vises på avtalt sted." },
          ]
        },
        passengers: {
          title: "Passasjerer",
          list: [
            { content: "Passasjerer skal møte opp på avtalt sted til avtalt tid. Transportør er ikke forpliktet til å vente på at passasjerer som ikke overholder denne bestemmelsen." },
            { content: "Passasjerer er pålagt å overholde politiets bestemmelser under reisen." },
            { content: "Passasjerer er ansvarlige for eventuelle skader påført transportøren (spesielt for skader i bussen) og andre passasjerer." },
            { content: "Passasjerer er pålagt å bruke sikkerhetsbelter når de reiser." },
            { content: "Barn under 12 år som ikke overstiger 150cm, som transporteres i bussen må bruke sikkerhetsseter eller annet utstyr for transport av barn, tilsvarende barnets vekt og høyde. Barnet skal holde seg gjennom hele turen i et sikret beskyttelses sete. Passasjeren må varsle transportøren hvilke sikkerhetsseter som skal medbringes når du oppretter bestillingen." },
            { content: "Transportør er ikke ansvarlig for mindreårige som reiser uten voksne." },
            { content: "Transportør er ikke ansvarlig for ting som er etterlatt på bussen" }
          ]
        }
      },
      privacyPolicy: {
        title: "Personvernerklæring",
        introduction: {
          title: "Innledning",
          list: [
            { content: "<strong>Flyo AS</strong> (“vi“) er opptatt av at du skal ha tillit til oss og hvordan vi behandler dine personopplysninger. I denne personvernerklæringen forklarer vi derfor hvorfor vi samler inn informasjon om deg, hvordan vi bruker denne informasjonen og hvordan vi tar hensyn til ditt personvern." },
            { content: 'Personopplysninger er opplysninger og vurderinger som kan knyttes til en identifiserbar enkeltperson. Dette kan for eksempel være navn og kontaktinformasjon, kjøpshistorikk eller informasjon om interesser. ' },
            { content: "Bruk av personopplysninger må følge personopplysningsloven. Vi, som behandlingsansvarlig, vil sørge for at vi bruker personopplysninger om deg i samsvar med lovens regler." }
          ]
        },
        whatPersonalInformation: {
          title: "Hvilke personopplysninger har vi om deg",
          list: [
            { content: "Avhengig av hvilken informasjon du gir oss, hvordan du bruker våre tjenester, og hvilke tillatelser du gir oss, har vi disse opplysningene om deg:" },
            { content: '<strong>Opplysninger om deg:</strong> Informasjon du oppgir når du oppretter en brukerkonto eller bestiller billetter, som navn, adresse, telefonnummer og e-postadresse.' },
            { content: "<strong>Kjøpsinformasjon:</strong> Informasjon vi får når du kjøper billetter fra oss, som hva du har kjøpt, kortnummer og betalingsmetode (f.eks. Visa). Om du har brukerkonto hos oss vil du få oversikt over dine tidligere kjøp i din brukerkonto." },
            { content: "<strong>Kommunikasjon:</strong> Informasjon du gir oss når du har kontakt med vårt kundesenter, som eposter sendt mellom oss." },
            { content: "<strong>Opplysninger om bruk på nettsidene:</strong> Informasjon vi får når du bruker vår nettside og app, som hva slags enhet du har (f.eks. mobil eller PC), IP-adresse, hvilke sider du besøker og hvilke funksjoner du bruker der." },
            { content: "<strong>Profileringsopplysninger:</strong> Informasjon og antakelser vi lager automatisk basert på de andre opplysningene (nevnt ovenfor) vi har om deg, som dine preferanser og interesser og hvilke demografiske grupper du tilhører, med mindre du har motsatt deg dette." },
          ]
        },
        whatWeUsePersonalInformationFor: {
          title: "Hva bruker vi personopplysningene til",
          list: [
            { content: "Vi bruker personopplysningene dine til følgende formål:" },
            { content: '<strong>Tilby nettside og app:</strong> Vi bruker opplysninger for å tilpasse vår nettside og app til det tekniske utstyret du bruker.' },
            { content: "<strong>Gjennomføre billettbestillinger:</strong> Vi bruker opplysninger for å gjennomføre ditt kjøp av billetter, bl.a. for å sende deg billettene, motta betaling og lagre kjøpshistorikk." },
            { content: "<strong>Opprette brukerkonto:</strong> Vi bruker opplysninger dersom du oppretter brukerkonto, bl.a. for å gi deg tilgang med brukernavn og passord, for å lagre din kontaktinformasjon og betalingsinformasjon, og for at du kan se din kjøpshistorikk." },
            { content: "<strong>Kundeservice:</strong> Vi lagrer opplysninger som du gir og mottar dersom du har kontakt med oss for å yte service og administrere ditt kundeforhold." },
            { content: "<strong>Statistikk:</strong> Vi utarbeider statistikk og kartlegger markedstrender for å forbedre og videreutvikle våre produkter og tjenester. Så langt det er mulig gjør vi dette med anonyme opplysninger, uten at vi vet at informasjonen er knyttet spesifikt til deg." },
            { content: "<strong>Markedsføring:</strong> Vi bruker din kontaktinformasjon (f.eks. telefonnummer og epostadresse) til å sende deg anbefalinger og informasjon om våre forestillinger. Vi kan bruke profileringsopplysninger for å gjøre anbefalingene og informasjonen mest mulig relevant for deg, med mindre du har motsatt deg dette. Hvis du ønsker det, vil vi også sende deg anbefalinger og informasjon om våre samarbeidspartneres forestillinger." },
            { content: "Det rettslige grunnlaget for formål <strong>1</strong>, <strong>4</strong> og <strong>5</strong> er vår berettigede interesse i å kunne tilby, videreutvikle og markedsføre våre tjenester." },
            { content: "Det rettslige grunnlaget for formål <strong>2</strong>, <strong>3</strong> og <strong>4</strong> er for å oppfylle vår kontrakt med deg." },
            { content: "Det rettslige grunnlaget for formål <strong>5</strong> kan også være ditt samtykke, dersom du har gitt oss dette. Det kan være nødvendig for å sende deg markedsføring dersom du ikke lenger har brukerkonto hos oss, eller dersom vi sender deg markedsføring om våre samarbeidspartneres forestillinger." },
          ]
        },
        whoWeSharePersonalInformationWith: {
          title: "Hvem deler vi personopplysninger med",
          list: [
            { content: "Vi deler personopplysninger med selskaper som leverer tekniske og administrative tjenester til oss, slik som IT-leverandører. Vi har avtaler med disse for å sikre ditt personvern." },
            { content: "Vi kan utlevere opplysninger i enkelttilfeller, eksempelvis til offentlige myndigheter, ved mistanke om lovbrudd." },
            { content: "Hvis du samtykker, kan vi dele dine personopplysninger med våre samarbeidspartnere som beskrevet i ditt samtykke. Dette kan f.eks. være konsertpromotører, teaterpromotører og andre teatre og kinoer, slik at de kan sende deg anbefalinger og informasjon som er relevante for deg, eller slik at de kan foreta egne markedsanalyser og tjenesteutvikling." },
            { content: "Vi benytter oss av IT-leverandører utenfor EØS. Vi kan for øvrig dele anonymiserte opplysninger med samarbeidspartnere for bl.a. markedsanalyser og tjenesteutvikling." },
          ]
        },
        howLongWeStorePersonalInformation: {
          title: "Hvor lenge lagrer vi personopplysninger",
          list: [
            { content: "Vi lagrer opplysninger om deg, kun så lenge det er nødvendig for å oppnå formålet de ble innhentet for, eller dersom vi er pålagt å lagre opplysningene. Opplysningene vil slettes eller anonymiseres når de ikke lengre er nødvendige for å oppnå formålet. Under er en oversikt over hvor lenge vi lagrer dine opplysninger:" },
            { content: "<strong>Opplysninger om deg:</strong> Hvis du har brukerkonto hos oss, kan du kontekte oss så sletter vi opplysningene vi har om deg." },
            { content: "<strong>Kjøpsinformasjon:</strong> Hvis du har brukerkonto hos oss, lagrer vi kjøpshistorikken din. Vi lagrer transaksjoner og betalingsinformasjon i 5 år i henhold til bokføringsloven." },
            { content: "<strong>Opplysninger om bruk på nettsidene:</strong> Vi lagrer informasjon om din bruk av våre nettsider i opptil 6 måneder." },
            { content: "<strong>Opplysninger fra partnere:</strong> Vi lagrer eventuell informasjon fra samarbeidspartnere så lenge du har en aktiv brukerkonto hos oss eller så lenge du har samtykket. Vi vil slette opplysningene dersom du sier opp brukerkontoen." },
            { content: "<strong>Kommunikasjon:</strong> Vi lagrer kommunikasjon med våre kunder i tre år, med mindre vi trenger å lagre det lenger, f.eks. i forbindelse med klager eller krav." },
            { content: "<strong>Profileringsopplysninger:</strong> Hvis du har brukerkonto hos oss, sletter vi opplysningene når du sier opp brukerkontoen eller brukerkontoen har. Vi vil slette opplysningene tidligere hvis du motsetter deg å bli profilert." },
          ]
        },
        yourRights: {
          title: "Dine rettigheter",
          list: [
            { content: "Du kan ha rett til å be oss å:" },
            {
              list: [
                { content: "Gi deg ytterligere informasjon om hvordan vi behandler dine personopplysninger." },
                { content: "Gi deg en kopi av personopplysninger om deg." },
                { content: "Oppdatere dine personopplysninger." },
                { content: "Slette opplysninger som vi ikke lengre har grunnlag til å oppbevare." },
                { content: "Begrense eller stoppe behandlingen av dine opplysninger." },
                { content: "Motsette deg automatiske individuelle avgjørelser, inkludert profilering." },
                { content: "Gi deg opplysninger du har gitt til oss i en strukturert, alminnelig anvendt og maskinlesbart format eller, der det er teknisk mulig, be oss om å overføre disse til en annen virksomhet." },
                { content: "Trekke tilbake eventuelle samtykker du har gitt oss." },
              ]
            },
            { content: "Vær klar over at det finnes begrensninger i disse rettighetene. Ta gjerne kontakt med oss hvis du vil ha mer informasjon om dette." },
            { content: "Hvis du mener at vi behandler personopplysninger i strid med personopplysningsloven, har du rett til å klage til Datatilsynet. Før du eventuelt gjør dette, vil vi gjerne at du kontakter oss slik at vi kan besvare dine spørsmål eller oppklare eventuelle misforståelser." },
          ]
        },
        cookies: {
          title: "Cookies",
          list: [
            { content: "Vi bruker cookies på våre nettsider for å sikre funksjonalitet på nettsiden, analysere nettrafikk og se hvilke områder på vårt nettsted du har besøkt." },
          ]
        },
        changesToThePrivacyStatement: {
          title: "Endringer i personvernerklæringen",
          list: [
            { content: "Vi vil kunne oppdatere personvernerklæringen fra tid til annen. Du vil få beskjed om endringer av betydning. Du vil alltid finne siste versjon av vår personvernerklæring på nettsiden/appen." },
          ]
        },
        contactInformation: {
          title: "Kontaktinformasjon",
          list: [
            { content: "Hvis du ønsker å komme i kontakt med oss, kan du benytte følgende kontaktinformasjon:" },
          ],
          address: [
            { content: 'Telefonnummer: <a href="tel:4796701103" itemProp="telephone">+47 96 70 11 03</a>' },
            { content: 'E-postadresse: <a href="mailto:info@pksoslo.com" itemProp="email">info@pksoslo.com</a>' },
            { content: 'Adresse: <span itemProp="streetAddress">Bekkenstenveien 53B</span>,<span itemProp="postalCode">0976</span> <span itemProp="addressLocality">Oslo</span>' },
          ]
        },
      },
    },
    notifications: {
      default: {
        success: "Suksess"
      },
      contact: {
        error: 'Feil',
        cannotBeSent: 'Kan ikke sende epost. Prøv igjen senere.',
        success: 'Melding sendt!',
        successMessage: 'Vi svarer deg så fort som mulig'
      },
      reviews: {
        error: 'Feil',
        noComment: 'Vennligst skriv inn en kommentar',
        success: 'Vurderingen har blitt lagret. Takk skal du ha!'
      },
      settings: {
        success: "Lagret",
        error: "Oops! Kan ikke lagre. Oppdater siden og prøv igjen."
      },
      invoices: {
        successMessage: "Informasjonen er lagret.",
        errorTitle: "Feil"
      },
      cards: {
        success: "Kortet er lagt til.",
        error: "Feil"
      },
      cardItems: {
        success: "Kortet er slettet..",
        error: "Feil",
        errorMessage: "Kunne ikke slette kort."
      },
      addressItem: {
        success: "Adressen er slettet.",
        error: "Feil",
        errorMessage: "Kunne ikke slette adresse."
      },
      addressComponent: {
        noResults: "No results",
        warning: {
          title: "Advarsel!",
          addressInvalid: "Adressen er ugyldig.",
          addressInDatabase: "Adressen er allerede lagret."
        }
      },
      facebook: {
        error: "Feil"
      },
      google: {
        error: "Feil"
      },
      loginPage: {
        error: "Feil"
      },
      loginForm: {
        success: "Du er logget inn.",
        error: "Feil"
      },
      bookingStep4: {
        error: "Feil"
      },
      phoneSmsVerification: {
        success: "Telefonnummeret er endret.",
        error: "Feil",
        errorMessage: "Skriv inn hele koden."
      },
      phoneNumberVerification: {
        success: "Kontoen er opprettet og du er logget inn.",
        error: "Error",
        invalidMessage: "Skriv inn hele koden."
      },
      profileResetPassword: {
        success: "Passordet har blitt endret.",
        error: "Feil"
      },
      mapPlaces: {
        success: {
          addressInDatabase: "Adressen er allerede lagret.",
        },
        warning:
        {
          title: "Advarsel!",
          addressSaved: "Adresse lagret.."
        },
        error: "Feil",
        errorMessage: "Kunne ikke slette adresse.",
      },
      reservationEdit: {
        error: "Feil",
        errorSubmit: "Feil!",
        warning: {
          title: "Advarsel!",
          message: "Bestillingen er ikke endret."
        }
      },
      suplementSummary: {
        success: "Endringer i bestillingen din er lagret.",
        error: "Feil"
      },
      notificationButtons: {
        cancelSuccess: "Bestillingen er kansellert.",
        error: "Feil",
      }
    },
    supplementSummary: {
      paySupl: "Betal"
    },
    reservationEdit: {
      address: "Adresse",
      editAddress: "Endre adresse",
      passengers: "Passasjerer",
      adults: "voksne",
      kids: "barn",
      students: "studenter",
      editPassengers: "Endre passasjerer",
      oldPrice: "Tidligere pris",
      changePrice: "Endring i pris",
      newPrice: "Ny pris",
      payWithCard: "Du har valgt å betale med kort",
      payDriver: "Du har valgt å betale til sjåføren. Du blir ikke belastet nå.",
      changeDetails: "Endre bestilling",
      changeNothing: "Jeg ønsker ikke å endre noe",
      reservationEditPassengers: {
        title: "Passasjerer",
        desc: "Endring av planer? Oppdater antall passasjerer.",
        adults: "voksne",
        kids: "barn",
        students: "studenter",
        kidsSafetyTitle: "Barneseter",
        tripMessage: "Du reiser med barn.",
        carSeatsMessage: "Hvilke barneseter trenger du?",
      }
    },
    form: {
      inputPhoneNumber: "telefonnummer",
      changePhoneNumber: "Endre telefonnummer",
      changePassword: "Endre passord",
      changePhoneAndPassword: "Endre telefonnummer og passord",
      changePhoneDescriptionFirst: "Nytt telefonnummer må bekreftes igjen",
      changePhoneDescriptionSecond: "Vi sender deg en bekreftelseskode på SMS.",
      changePhoneSuccessMessage: "Telefonnummeret er endret."
    },
    errors: {
      passengerCount: "Velg riktig antall passasjerer.",
      childrenSeats: 'Velg barnesete',
      card: {
        cardNumber: 'Feil kortnummer',
        cardCvc: 'Feil CVC',
        date: 'Feil dato',
        datePast: 'Dato kan ikke være i fortiden'
      },
        contact: {
        email: 'Eposten er ugyldig',
        name: 'Navn er ugyldig',
        message: 'Meldingen er ugyldig',
      },
      auth: {
        loginPage: {
          passwordBlank: 'oppgi passord'
        },
        loginForm: {
          passwordBlank: 'oppgi passord'
        },
        newPassswordAndCode: {
          codeFull: "Skriv inn hele koden",
          codeEmpty: 'Skriv inn koden'
        },
        emailForm: {
          emailEmpty: "E-postadresse er påkrevd",
          emailInvalid: "Ugyldig e-postadresse",
          requestError: "En feil oppstod. Vennligst prøv igjen."
        },
        customerBasicValidation: {
          nameToShort: "Minimum 3 tegn",
          nameToLong: "Navnet er for langt",
          emailInvalid: "Ugyldig epost",
          passwordToShort5chars: "Minimum 5 tegn",
          passwordToLong: "Passordet er for langt",
        },
        customerAddressValidation: {
          latEmpty: "Lat cannot be empty",
          lngEmpty: "Lng cannot be empty",
          streetEmpty: "Adressen kan ikke være tom",
          postCodeEmpty: "Postnummeret kan ikke være tomt",
          typeEmpty: "Type cannot be empty"
        },
        customerPhoneValidation: {
          exactlyLength: "Telefonnummeret må ha %size% siffer",
          minNumbersPre: "Minimum",
          minNumbersPost: "tegn",
          phoneToLong: "Telefonnummeret er for langt",
          countryCodeEmpty: "Mangler landskode"
        },
        registrationFormStep1: {
          emailBusy: "Epost er allerede i bruk"
        }
      }
    },
    auth: {
      loginPage: {
        title: "Hei! Godt å se deg.",
        subtitle: "Fortsett med",
        authSeparator: "eller",
        passwordLabel: "passord",
        forgotPassword: "Glemt passord?",
        logIn: "Logg inn",
        accountInfo: "Har du ikke en konto?",
        createAccount: "Opprett en",
      },
      newPassswordAndCode: {
        title: 'Tilbakestill passord',
        codeTitle: 'Vi har sendt deg en 4-sifret bekreftelseskode',
        codeSentTo: 'til',
        newPasswordLabel: "nytt passord",
        backToEmail: "Tilbake til e-post",
        changePasswordButton: "Endre passord"
      },
      emailForm: {
        title: "Tilbakestill passord",
        description: "Skriv inn e-postadressen din så sender vi deg en bekreftelseskode.",
        emailLabel: "E-postadresse",
        remember: "Jeg husker det! ",
        goBack: "Gå tilbake",
        resetPasswordButton: "Tilbakestill passord",
        successMessage: "Passordet ble endret"
      },
      registrationForm: {
        title: 'Fortsett med',
        or: 'eller',
        signUpEmail: 'Registrer deg med epost',
        haveAccount: 'Har du allerede en konto?',
        logIn: 'Logg inn'
      },
      registrationFormStep1: {
        header: 'Hyggelig å møte deg',
        labels: {
          fullname: "Navn og etternavn",
          email: "epost",
          password: "passord"
        },
        terms: {
          first: "Ved å fortsette, godtar du våre",
          second: "Vilkår for bruk",
          and: "og",
          third: "Personvern"
        },
        haveAccount: 'Har du allerede en konto?',
        logIn: 'Logg inn'
      },
      registrationFormStep2: {
        linkTitle: "Endre kontaktinformasjon",
        title: "Nesten ferdig",
        description: "Vennligst kontroller at telefonnummeret er riktig.",
        descriptionSms: "Vi sender deg en bekreftelseskode på SMS."
      },
      registrationFormStep3: {
        headerLinkTitle: "Endre e-post",
        headerTitle: "Skriv inn bekreftelseskoden",
        headerDescription: "Vi har sendt deg en 4-sifret bekreftelseskode til %email%",
        wrongQuestion: "Feil e-post?",
        change: "Endre det",
        changeTitle: "Endre e-post",
        receiveCodeQuestion: "Fikk du ikke koden?",
        sendAgain: "Send igjen",
        separator: "eller",
        skipTitle: "Hopp over",
        skip: "fortsett uten konto",
        done: "Ferdig"
      }
    },
    userData: {
      backToAddress: "Tilbake til adresse",
      backToPersonalData: "Tilbake til Kontaktinformasjon",
      personalData: "Kontaktinformasjon",
      loginForm: {
        accountInfo: "Har du ikke konto?",
        register: "Registrer deg",
        passwordLabel: "passord"
      },
      registerForm: {
        accountInfo: "Har du allerede en konto?",
        logIn: " Logg inn",
        labels: {
          fullname: "Navn og etternavn",
          email: "epost",
          password: "passord"
        },
        createAccount: "Opprett konto?",
      },
      changePhoneForm: {
        sendCodeInfo: "Vi har sendt deg en 4-sifret bekreftelseskode til %phone_label% %phone_number%",
        backToPhone: "Tilbake til telefonnummer",
        done: "Ferdig"
      }
    },
    addressItem: {
      deleteTitle: 'Slett adresse',
      deleteQuestion: 'Er du sikker på at du vil slette adressen?',
      confirmButton: 'Ja',
      rejectButton: 'Nei, behold den',
      deletePlaceTitle: 'Slett sted'
    },
    account: {
      editProfileTitle: 'Endre profil',
      menu: {
        myTrips: 'Mine turer',
        cards: 'Mine kort',
        places: 'Mine steder',
        invoices: 'Kvittering',
        settings: 'Instillinger'
      },
      card: {
        deleteCard: 'Slett kort',
        deleteCardMessage: 'Er du sikker på at du vil slette kortet?',
        title: 'Mine kort',
        stripeTitle: 'Sikker betaling via Stripe',
        addNewCardTitle: 'Legg til nytt kort',
        cardNumberPlaceholder: 'Kortnummer',
        cardDatePlaceholder: 'MM/ÅÅ',
        cardCvcPlaceholder: 'CVC',
        addCardButton: 'Legg til kort',

        removeBtnConfirm: 'Ja',
        removeBtnCancel: 'Nei, behold det',
        chooseCard: 'velg kort',
        emptyCardsList: 'Du har ingen lagrede kort.',
        addNewCardButton: 'Legg til nytt kort',

        addNewOne: 'legg til',
        saveCard: 'Lagre kort',
        invoiceInfo: 'Kvitteringsinformasjon',
      },
      places: {
        title: 'Mine steder',
        myPlaces: 'Mine steder',
        list: {
          favPlacesEmpty: 'Du har ingen lagrede steder.',
          addNewAddress: 'Legg til ny adresse'
        }
      },
      invoices: {
        invoiceInfo: 'Kvitteringsinformasjon',
        invoiceSave: "Lagre",
        form: {
          companyNameLabel: 'Firmanavn',
          addressLabel: 'Adresse',
          taxNumberLabel: 'Organisasjonsnummer',
          checkboxInfo: 'Kvittering for hver bestilling',
        },
      },
      settings: {
        title: 'Instillinger',
        notifications: 'Varsler',
        language: 'Språk',
        logout: 'Logg ut',
        langs: {
          en: 'English',
          no: 'Norsk',
          pl: 'Polski',
          ru: 'Русский'
        }
      }
    },
    login: {
      title: 'Innloggingspanel',
      footer: 'footer'
    },
    sessions: {
      login: {
        title: 'Innloggingsskjema',
        email: 'Skriv inn epost',
        password: 'Skriv inn passord'
      }
    },
    dashboard: {
      myTrips: "Mine turer",
      filterByDate: 'Velg dato',
      getInvoice: 'Last ned kvittering',
      notFoundTrips: "Ingen turer funnet",
      upcoming: "Kommende turer",
      payToDriver: 'Betal til sjåfør',
      payWithCard: 'Betalt med kort',
      notificationButtons: {
        cancelBookingConfirm: "Ja, slett denne bestillingen",
        cancelBookingText: "Nei, behold den",
        refundInfo: "Hvis du har betalt med kort, vil du bli tilbakebetalt innen 10 virkedager",
        infoWithoutRefundNotification: "Du avbestiller mindre enn 8 timer før planlagt flytur. Du blir ikke tilbakebetalt.",
        editButton: "Endre",
        cancel: "Kanseller",
        booking: "Bestilling",
        cancelBooking: {
          title: "Er du sikker på at du vil slette bestillingen?",
          message: "%on% fra %from% til %to%"
        },
        closeTitle: "Lukk"
      },
      slider: {
        title: "Hvordan var turen din med %driverName%?",
        desc: "den %date% fra %from% til %to%",
        content: "Hvordan var turen din? Vi vil være glade for din tilbakemelding!",
        addReview: "Legg til vurdering",
        closeReview: "Lukk vurdering",
        textAreaPlaceholder: "Fortell oss mer ..."
      },
      summary: {
        newPrice: "Ny pris",
        changePrice: "Endring i pris",
        paySupl: "Betal",
        refund: "Tilbakebetaling",
        oldPrice: "Tidligere pris",
        changesSaved: "Dine endringer har blitt lagret",
        payDriver: "Du har valgt å betale til sjåføren. Du kan betale med kort eller kontant.",
        buttonText: "OK"
      }
    },
    invoiceCheckbox: {
      company: "Firma betaler?",
      addInvoice: "Legg til kvitteringsinformasjon",
      canceledInfo: "Din kvitteringsforespørsel blir kansellert",
      fillTheForm: {
        first: "Vennligst",
        last: " fyll ut hele skjemaet"
      },
      issueInvoice: "Utsted kvittering til ",
      changeInfo: "Endre kvitteringsinformasjon?"
    },
    flyOut: 'Fly ut',
    flyBack: 'Fly tilbake',
    common: {
      success: "Suksess",
      error: "Feil",
      terms: "Vilkår og betingelser",
      privacyPolicy: "Personvern",
      logIn: "Logg inn",
      signUp: "Registrer deg",
      bookNow: "Bestill nå",
      nothingInfo: "Det er ingenting her",
      nothingMessage: "Dine bestillinger vil være tilgjengelige her.",
      previous: "Forrige",
      loggedInError: "Du må være logget inn",
      loggedInMessage: "Velkommen tilbake!",
      skipToLogin: "Logg inn",
      somethingWrong: "Oops! Noe gikk galt.",
      optional: 'valgfri',
      adults: 'voksne',
      kids: 'barn',
      under: 'under',
      students: 'studenter',
      step: 'steg',
      next: 'Fortsett',
      price: 'pris',
      currency: 'kr',
      backToBooking: 'Tilbake til Bestilling',
      backToLogin: 'Tilbake til Logg inn',
      backToProfile: 'Tilbake til Profil',
      ok: 'Ok',
      signUpWithEmail: 'Registrer med epost',
      close: 'Lukk',
      show: 'Vis',
      hide: 'Skjul',
      back: 'Tilbake',
      save: 'Lagre',
      inputs: {
        oldPassword: 'gammelt passord',
        newPassword: 'nytt passord'
      },
      contact: {
        phone: "(+47) 96 70 11 03",
        phoneTitle: "Ring oss",
        email: "info@pksoslo.com",
        emailTitle: "Send oss en epost"
      }
    },
    calendar: {
      oneWay: 'En vei',
      confirm: 'Ok'
    },
    bookingStep1: {
      mobile: {
        selectDate: 'Velg dato',
        selectDates: 'Velg dato',
        selectAirportLabel: 'Velg flyplass',
        selectAirportTitle: 'Velg flyplass',
      },
      headerChooseAirport: 'Velg flyplass',
      header: 'Bestill Flyplasstransport',
      whatFlight: 'Hvilken flyvning skal du til?',
      chooseAirport: {
        listEmpty: 'Ingen flyplass funnet, prøv igjen.',
        from: 'Fra flyplass',
        to: 'Til flyplass',
      },
      chooseAirportPlaceholder: 'Velg flyplass...',
      chooseAirportFrom: 'Fra',
      chooseAirportTo: 'Til',
      chooseSelectDate: 'Velg dato',
      chooseSelectDatePlaceholder: 'Se kalender',
      letsGo: 'Fortsett',
      errors: {
        date: 'Velg dato',
        passengers: 'Velg passasjerer',
        place: 'Velg plassering',
        location_same: 'Plasseringene kan ikke være like',
        two_airports: 'Du kan ikke velge to flyplasser',
        two_cities: 'Du kan ikke velge to byer'
      }
    },
    kidsSafety: {
      labels: {
        firstAge: '0-15 måneder',
        firstWeight: '0-13kg',
        secondAge: '1-4 år',
        secondWeight: '9-18kg',
        thirdAge: '4-12 år',
        thirdWeight: '15-36kg',
        fourthAge: '4+ år',
        fourthWeight: '15-36kg',
      },
      title: 'Barneseter',
      tripWithCount: 'Du reiser med ',
      tripWithCountSufix: ' barn.',
      typeOfSeatsQuestion: 'Hvilken type barneseter trenger du?',
      safetyList: {
        chooseTitle: 'Du må velge ',
        chooseTitleSufix: ' til',
        items: {
          cradle: 'Babystol',
          seatWithSeatBelts: 'Småbarnstol',
          seatWithoutSeatBelts: 'Beltestol',
          carSeatPad: 'Beltepute',
          noNeedCarSeat: 'Jeg trenger ikke barnesete'
        }
      }
    },
    bookingStep2: {
      chooseFlyOut: 'Fly ut',
      chooseFlyBack: 'Fly tilbake',
      editKids: 'Endre Barneseter',
      errors: {
        flight: {
          departure: 'Du må velge en flyvning',
          return: 'Du må velge en flyvning'
        }
      }
    },
    // map
    bookingStep3: {
      map: {
        backToSelectFlight: 'Tilbake til Flyvninger',
        addAddress: {
          first: 'Legg til ',
          second: ' annen ',
          third: ' returadresse'
        },
        removeReturnAddress: 'Slett returadresse',
        addToFav: "Legg til i favoritter"
      },
      address: {
        inputPlaceholder: 'Skriv inn adresse eller velg bussholdeplass'
      },
      favButton: 'Legg til i favoritter',
      favSpotButton: 'Lagre som:',
      spots: {
        home: 'Hjem',
        work: 'Jobb',
        other: 'Annet'
      },
      summary: {
        from: 'fra',
        to: 'til',
        totalPrice: 'Totalpris:',
        smsInfoFirst: 'Vi sender deg en SMS med hentetidspunktet',
        smsInfoSecond: 'en dag før planlagt avgang.',
        tooltip: {
          button: 'Mer om henting',
          departures: 'Flyavgang: Du mottar en SMS dagen før avreise kl. 18.00 med tidspunktet for henting.',
          arrivals: 'Flyankomst: Din sjåfør vil vente på deg utenfor terminalen.',
        }
      },
      errors: {
        postCode: 'Mangler postnummer.',
        street: 'Mangler husnummer.',
        coords: 'Koordinater ikke funnet for den valgte adressen.',
        addressNotFound: 'Fant ikke adresse.',
        connection: 'Kunne ikke koble til serveren.', // general info when something is wrong with connection ...
        addressNotSupported: 'Beklager! Vi kjører ikke til denne adressen.',
        selectAddress: 'Vennligst velg adresse'
      }
    },
    //summary
    bookingStep4: {
      stepHeader: {
        title: 'Bestillingsdetaljer',
        linkTitleAddressSelection: 'Tilbake til adresse',
        linkTitleUserSelection: 'Tilbake til bruker'
      },
      summary: {
        title: 'Bestillingsdetaljer',
        totalPrice: 'Totalpris',
        bookNow: 'Bestill',
        payToDriver: 'Betal til sjåfør',
        payUsingCard: 'Betal med kort',
        passengerData: 'Passasjerdetaljer:',
        phoneFormat: 'Format: +XXXXXXXXX'
      },
      address: {
        return: 'Fly tilbake: ',
        departure: 'Fly ut: '
      },
      errors: {
        payment: {
          emptyData: 'Mangler data. Fullfør bestillingsskjemaet for å fortsette.',
          selectPaymentMethod: 'Velg betalingsmetode',
          cardDetails: 'Skriv inn betalingskortinformasjon',
          paymentFailed: 'Det oppsto en feil under betalingen'
        },

        map: {
          addressNotSupported: ' Beklager! Vi kjører ikke til denne adressen.',
          addressEmpty: 'Ingen adresse valgt',
          addressPostalCode: 'Denne adressen har ingen postnummer',
          streetNumber: 'Skriv inn husnummer',
          streetCoords: 'Koordinater ikke funnet for den valgte adressen',
        }
      }
    },
    bookingStepFinal: {
      title: 'Takk for at du kjører med oss',
      info: {
        first: 'Din bestilling har blitt sendt.',
        second: 'Du kan endre bestillingen din inntil kl. 18.00 dagen før avreise.',
        third: 'Om du lurer på noe er det bare å kontakte oss!'
      },
      confirm: 'Ok'

    },
    homepage: {
      title: 'FLYREISEN GJORT ENKELT',
      content: `Velg en flyvning til eller fra Oslo Sandefjord Torp,
       deretter bestill minibussen din ved å ringe oss eller via websiden vår.
       Vi henter deg hjemme, på jobben eller flyplassen.
       SMS with confirmation of bus arrival time.
       We will also call for a moment before appearing at the address indicated.`
    },
    prices: {
      title: 'Prisliste flyplasstransport',
      content: 'Våre priser ved henting fra adresse og bussholdeplass'
    },
    help: {
      header: 'Hjelp',
      question: 'Har du spørsmål angående vår tjeneste?',
      checkLink: 'Sjekk ut linkene nedenfor eller kontakt oss.',
      officeWorks: 'Vi jobber hver dag fra kl. 08.00 til 21.00.',
      rightsReserved: '© 2019 Flyo AS. All rights reserved.'
    }
  },
  routes: {
    url: {
      booking: '/:locale/booking',
      kidsSafety: '/:locale/booking/kids-safety',
      flights: '/:locale/booking/flight',
      map: '/:locale/booking/map',
      transferPage: '/:locale/transfer-oslo-gardermoen',
      aiportTransfer: '/:locale/transfer-oslo-gardermoen',
      userData: '/:locale/booking/user-data',
      confirmPhone: '/:locale/booking/confirm-phone',
      summary: '/:locale/booking/summary',
      confirmed: '/:locale/booking/confirmed',
      signup: '/:locale/signup',
      registrationStep1: '/:locale/registration-step-1',
      registrationStep2: '/:locale/registration-step-2',
      registrationStep3: '/:locale/registration-step-3',
      login: '/:locale/login',
      resetPassword: '/:locale/reset-password',
      dashboard: '/:locale/dashboard',
      dashboardEdit: '/:locale/dashboard/edit/:id',
      dashboardReservationPayment: '/:locale/dashboard/reservation-payment',
      help: '/:locale/help',
      accountTrips: '/:locale/account/my-trips',
      account: '/:locale/account',
      accountProfile: '/:locale/account/profile',
      accountCards: '/:locale/account/cards',
      accountPlaces: '/:locale/account/places',
      accountPlacesMap: '/:locale/account/map',
      accountInvoices: '/:locale/account/invoices',
      accountSettings: '/:locale/account/settings',

      home: '/no',
      howItWorks: '/:locale/hvordan-det-fungerer',
      prices: '/:locale/pris',
      faq: '/:locale/ofte-stilte-sporsmal',
      contact: '/:locale/kontakt-oss',
      termsAndConditions: '/:locale/terms',
      privacyPolicy: '/:locale/privacy-policy',
    },
    name: {
    }
  },
  test: { test: "Hei!" },
  errors: {
    notFound: {
      title: "404",
      content: "Oops! Vi fant ikke siden du ser etter."
    }
  }
}
